import { TEST_IDS } from '@va/constants';
import { BulbIcon, CloseIcon, RadioInputSelected } from '@va/icons';
import classNames from 'classnames';
import { PropsWithChildren, ReactNode } from 'react';
import { Button } from './button';
import { IconWithBackground } from './icon-with-background';

type ImportantHintBannerProps = {
  wrapperClassName?: string;
  onClose?: (() => void) | null;
  dataTestId?: string;
  icon?: ReactNode;
  hideHighlightIcon?: boolean;
};

export const ImportantHintBanner = ({
  children,
  wrapperClassName,
  onClose,
  dataTestId,
  icon,
  hideHighlightIcon,
}: PropsWithChildren<ImportantHintBannerProps>) => {
  return (
    <div
      className={classNames('bg-primary p-3 px-4 rounded-24 flex gap-3 items-center', wrapperClassName)}
      data-testid={dataTestId}
    >
      <div className='relative'>
        <IconWithBackground className='bg-white-snow' icon={() => icon ?? <BulbIcon color={window.PRIMARY_COLOR} />} />
        {!hideHighlightIcon && (
          <div className='absolute top-1/2 left-0 -translate-y-1/2 -translate-x-1/2 flex items-center justify-center'>
            <RadioInputSelected color='#EA2A0C' className='w-4 h-4' />
            <div className='absolute top animate-circle bg-red-600 w-10 h-10 rounded-full'></div>
          </div>
        )}
      </div>
      <div className='text-white'>{children}</div>
      {onClose && (
        <Button
          data-testid={TEST_IDS.generic.buttons.close}
          onClick={onClose}
          className={'ml-auto brightness-125 cursor-pointer'}
          icon={(_, color) => <CloseIcon color={color} />}
        />
      )}
    </div>
  );
};
